import React, { useState } from "react";
import { Checkbox, Space, Dropdown, Button, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";

const BloodStock = () => {
  const [checkedItems, setCheckedItems] = useState({});

  const childrenValuesBloodType = [
    { label: "A+", value: "A+" },
    { label: "A-", value: "A-" },
    { label: "B+", value: "B+" },
    { label: "B-", value: "B-" },
    { label: "AB+", value: "AB+" },
    { label: "AB-", value: "AB-" },
    { label: "O+", value: "O+" },
    { label: "O-", value: "O-" },
  ];

  const bloodStockOptions = [
    {
      label: "Whole Blood",
      value: "Whole Blood",
      children: childrenValuesBloodType,
    },
    {
      label: "Packed Red Blood Cell [PRBC]",
      value: "Packed Red Blood Cell",
      children: childrenValuesBloodType,
    },
    {
      label: "Fresh Frozen Plasma [FFP]",
      value: "Fresh Frozen Plasma",
      children: childrenValuesBloodType,
    },
    {
      label: "Leukocyt Reduced PRBCs",
      value: "Leukocyt Reduced PRBCs",
      children: childrenValuesBloodType,
    },
    {
      label: "Washed RBCs",
      value: "Washed RBCs",
      children: childrenValuesBloodType,
    },
    {
      label: "Granulocytes Concentrates",
      value: "Granulocytes Concentrates",
      children: childrenValuesBloodType,
    },
    {
      label: "Platelets",
      value: "Platelets",
    },
    {
      label: "Cryoprecipitate",
      value: "Cryoprecipitate",
    },
    {
      label: "Plasma Derivation",
      value: "Plasma Derivation",
      children: [
        { label: "Albumin", value: "Albumin" },
        { label: "Immunoglobin", value: "Immunoglobin" },
        { label: "Coagulation Factor Concentrate", value: "Coagulation Factor Concentrate" },
      ],
    },
  ];

  const handleParentChange = (parentValue, checked) => {
    setCheckedItems((prev) => {
      const updated = { ...prev };
      updated[parentValue] = checked;

      const parent = bloodStockOptions.find((opt) => opt.value === parentValue);
      if (parent?.children) {
        parent.children.forEach((child) => {
          updated[child.value] = checked;
        });
      }

      return updated;
    });
  };

  const handleChildChange = (parentValue, childValue, checked) => {
    setCheckedItems((prev) => {
      const updated = { ...prev, [childValue]: checked };

      const parent = bloodStockOptions.find((opt) => opt.value === parentValue);
      const allChildrenChecked = parent.children?.every(
        (child) => updated[child.value]
      );
      updated[parentValue] = allChildrenChecked;

      return updated;
    });
  };

  const renderDropdownMenu = (parent) =>
    parent.children ? (
      <Menu>
        {parent.children.map((child) => (
          <Menu.Item key={child.value}>
            <Checkbox
              checked={checkedItems[child.value] || false}
              onChange={(e) =>
                handleChildChange(parent.value, child.value, e.target.checked)
              }
            >
              {child.label}
            </Checkbox>
          </Menu.Item>
        ))}
      </Menu>
    ) : null;

  return (
    <div className="blood-stock-container">
      <Space direction="vertical">
        {bloodStockOptions.map((parent) => (
          <div key={parent.value}>
            <Checkbox
              checked={checkedItems[parent.value] || false}
              onChange={(e) =>
                handleParentChange(parent.value, e.target.checked)
              }
            >
              {parent.label}
            </Checkbox>
            {parent.children ? (
              <Dropdown
                overlay={renderDropdownMenu(parent)}
                trigger={["click"]}
                placement="bottomLeft"
              >
                <Button
                  type="link"
                  style={{ marginLeft: "20px", padding: 0 }}
                  icon={<DownOutlined />}
                >
                  Select Blood Types
                </Button>
              </Dropdown>
            ) : (
              <span style={{ marginLeft: "20px", color: "gray" }}>
                No options available
              </span>
            )}
          </div>
        ))}
      </Space>
    </div>
  );
};

export default BloodStock;
